export default "__VITE_PUBLIC_ASSET__a4a166da__"